import { FC } from 'react';
import {
  ListItem,
  ListItemText,
  Skeleton,
} from '@mui/material';

export const AnsweredAssertionRow: FC<Assertions.Assertion> = assertion => {
  
  return (
    <ListItem divider>
      <ListItemText
        primary={assertion.content}
        secondary={assertion.userAnswer && (
          <>You answered: <strong>{assertion.userAnswer}</strong></>
        )}
      />
    </ListItem>
  );
};

export const AnsweredAssertionRowSkeleton: React.FC = () => {

  return (
    <ListItem divider>
      <ListItemText
        primary={<Skeleton width="60%" sx={{ maxWidth: 280 }} />}
        secondary={<Skeleton width="80%" sx={{ maxWidth: 300 }} />}
      />
    </ListItem>
  );
};
